import React from 'react';

// Styles & Assets
import styles from './HeaderPharmacy.module.css';

// Hooks 
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';

// Language
import { useTranslation } from 'react-i18next';

// Interfaces
interface DatePercentages {
    [date: string]: {
        taken: number;
        total: number;
    };
}

const HeaderPharmacy: React.FC<{
    children: React.ReactElement,
    datesPercentages: DatePercentages
    dates: string[]
    readOnly: boolean
}> = ({ children, datesPercentages, dates, readOnly }) => {

    const { t } = useTranslation();

    const [showDayAdminDialog, setShowDayAdminDialog] = useState<boolean>(false);
    const [time, setTime] = useState<string>('');

    const handleClickCell = (date: string) => {
        setShowDayAdminDialog(true);
        setTime(date);
    };

    const calculateColPercentage = (date: string) => {
        if (datesPercentages[date].total === 0) return '';
        return Math.round(datesPercentages[date].taken /
            datesPercentages[date].total * 100) + '%';
    };

    const DayAdminDialog = React.cloneElement(children, {
        date: time,
        showDialog: setShowDayAdminDialog
    });

    return (
        <>
            <thead>
                <tr>
                    <th className={`${styles.headerCell} ${styles.firstColumn}`}></th>
                    <th className={`${styles.headerCell} ${styles.blueCell} ${styles.viaAdmin}`}>
                        {t('administration_via')}</th>
                    {dates.map(date =>
                        <th
                            key={date}
                            data-date={date}
                            onClick={readOnly ? undefined : () => handleClickCell(date)}
                            className={`${styles.headerCell} ${readOnly ? '' : 'clickable'}`}
                        >
                            <p className={styles.timestamp}>{date.slice(8, 10)}/{date.slice(5, 7)}/{date.slice(0, 4)}</p>
                            <p className={styles.percentageColumn}>{calculateColPercentage(date)}</p>
                        </th>
                    )}
                    <th className={`${styles.headerCell} ${styles.blueCell} ${styles.adhesion7}`}>
                        <p>{t('adhesion')}<br></br>{t('_7_days')}</p>
                    </th>
                    <th className={`${styles.headerCell} pharmaCell ${styles.blueCell} ${styles.adhesionTotal}`}>
                        <p>{t('adhesion')}<br></br>{t('total')}</p>
                    </th>
                </tr>
            </thead >
            <Modal show={showDayAdminDialog} setShowModal={setShowDayAdminDialog}>
                {DayAdminDialog}
            </Modal>
        </>
    );
};

export default HeaderPharmacy;